<template>
  <div class="title-wrap">
    <div class="title-wrap__head">
      <h3 v-if="!$slots.custom">{{Title}}</h3>
      <slot name="custom"></slot>
    </div>
    <v-divider class="v-divider__primary" :class="[userTheme]"></v-divider>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Title', // eslint-disable-line
  computed: {
    ...mapState('userInfo', ['userInfo']),
    Title() {
      return this.$route.meta.remark;
    },
    userTheme() {
      let theme = '';
      if (this.userInfo.userStyle) {
        theme = this.userInfo.userStyle;
      }
      return theme;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-wrap{
  margin-bottom: 24px;
  &__head{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    h3{
      font-size: 1.5rem;
    }
  }
}
::v-deep .theme{
  &-default{
    border-color: $primaryColor08;
  }
  &-deep{
    border-color:#4C4C4C !important;
  }
  &-pink{
    border-color:#FC8099 !important;
  }
  &-blue{
    border-color:#4098E6 !important;
  }
}
</style>
